export default {"src":"/_next/static/media/motus_logo_hvitt.42a85575.svg","height":145,"width":279};